export default "__VITE_ASSET__CRIJdTcR__"